import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { Col, Button } from "reactstrap";
import {
  SearchableSelectHookForm,
  TextFieldHookForm,
} from "../../../layout/HookFormInputs";
import {
  getAllSupplierSpecializationService,
  getCountryService,
  getSelectSupplierCategoryService,
} from "../../VendorNeedForm/Actions";
import { getCityMasterServiceFilter, getTyBuisness } from "../Actions";

const MasterFilterComponent = ({ filter, onFilterChange, setSideBarFilterData }) => {
  
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
    register,
  } = useForm();
  const [buisnessType, setBuisnessType] = useState([]);
  const [categoryListData, setCategoryListData] = useState([]);
  const [specializationData, setSpecializationData] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [cityList, setCityList] = useState([]);
  useEffect(() => {
    getTypeOfBuisness();
    getSelectSupplierCategory();
    getSupplierSpecializationList();
    getCountryMasterList();
    getCityMasterListMasterFilter();
  }, []);
  const getSelectSupplierCategory = () => {
    getSelectSupplierCategoryService()
      .then((res) => {
        setCategoryListData(res?.Data);
      })
      .catch(() => { });
  };
  const getTypeOfBuisness = () => {
    getTyBuisness()
      .then((res) => {
        setBuisnessType(res?.Data);
      })
      .catch((error) => { });
  };

  const renderListing = (label) => {
    if (label === "CategoryData") {
      return categoryListData?.map((potentialSupplierData) => ({
        value: potentialSupplierData.Id,
        label: potentialSupplierData.Name,
      }));
    }
    if (label === "buisnessTypeData") {
      return buisnessType?.map((potentialSupplierData) => ({
        value: potentialSupplierData.Id,
        label: potentialSupplierData.BusinessTypeName,
      }));
    }
    if (label === "specialization") {
      return specializationData?.map((potentialSupplierData) => ({
        value: potentialSupplierData.Id,
        label: potentialSupplierData.SpecializationName,
      }));
    }
    if (label === "country") {
      return countryList.map((countryList) => ({
        value: countryList.Id,
        label: countryList.Name,
      }));
    }
    if (label === "city") {
      return cityList.map((cityList) => ({
        value: cityList.CityId,
        label: cityList.City,
      }));
    }
  };


  const getSupplierSpecializationList = () => {
    getAllSupplierSpecializationService()
      .then((res) => {
        setSpecializationData(res?.Data);
      })
      .catch((error) => { });
  };

  const getCountryMasterList = () => {
    getCountryService()
      .then((res) => {
        setCountryList(res?.Data);
      })
      .catch((error) => { });
  };

  const getCityMasterListMasterFilter = () => {
    getCityMasterServiceFilter()
      .then((res) => {
        setCityList(res?.Data);
      })
      .catch((error) => { });
  };

  const onFinish = (values) => {
    // Create the payload with all form field values
    const payload = {
      City: values.City || "", // Extract the value from the City object
      SupplierCategory: values.SupplierCategory?.value || "",
      TypeOfBusiness: values.TypeOfBusiness?.value || "",
      supplierSpecialization: values.supplierSpecialization?.label || "",
      SupplierType: values.SupplierType?.value || "",
      Country: values.Country?.value || "",
      PanNo: values?.panNo || "",
      supplierName: values.supplierName || "",
      // Add more fields as needed
    };
    // Call onFilterChange with the payload
    onFilterChange(payload);
    setSideBarFilterData(payload);
  };

  const handleReset = () => {
    setValue("City", ""); // Set City field to an empty string
    setValue("SupplierCategory", ""); // Set SupplierCategory field to an empty string
    setValue("TypeOfBusiness", ""); // Set TypeOfBusiness field to an empty string
    setValue("supplierSpecialization", ""); // Set supplierSpecialization field to an empty string
    setValue("SupplierType", ""); // Set SupplierType field to an empty string
    setValue("Country", ""); // Set Country field to an empty string
    setValue("panNo", ""); // Set panNo field to an empty string
    setValue("supplierName", ""); // Set supplierName field to an empty string

    onFilterChange({}); // Optionally, you can also reset any filter state managed by the parent component
  };

  return (
    <div className="supplier-inputs mt-3">
      <form
        onSubmit={handleSubmit(onFinish)}
        name="registration"
        layout="vertical"
      >
        <Col md="12">
          <SearchableSelectHookForm
            {...register("SupplierCategory")}
            label="Supplier Category"
            rules={{ required: false }}
            name="SupplierCategory"
            placeholder="Select"
            Controller={Controller}
            control={control}
            register={register}
            options={renderListing("CategoryData")}
            mandatory={false}
            handleChange={(value) => {
              //   handleSelectChange(value);
            }}
            errors={errors?.SupplierCategory}
            disabled={filter === "0" || filter === "2"}
          // disabled={false}
          />
        </Col>
        <Col md="12">
          <SearchableSelectHookForm
            {...register("TypeOfBusiness")}
            label="Type of Business"
            rules={{ required: false }}
            name="TypeOfBusiness"
            placeholder="Select"
            Controller={Controller}
            control={control}
            register={register}
            options={renderListing("buisnessTypeData")}
            mandatory={false}
            handleChange={(value) => {
              //   handleSelectChange(value);
            }}
            errors={errors?.TypeOfBusiness}
            disabled={filter === "0" || filter === "1" || filter === "3"}
          />
        </Col>
        <Col md="12">
          <SearchableSelectHookForm
            {...register("supplierSpecialization")}
            label="Supplier Specialization"
            rules={{ required: false }}
            name="supplierSpecialization"
            placeholder="Select"
            Controller={Controller}
            control={control}
            register={register}
            options={renderListing("specialization")}
            mandatory={false}
            handleChange={(value) => {
              //   handleSelectChange(value);
            }}
            errors={errors?.supplierSpecialization}
            disabled={filter === "0" || filter === "3"|| filter === "1"}
          />
        </Col>
        <Col md="12">
          <SearchableSelectHookForm
            {...register("SupplierType")}
            label="Supplier Type"
            rules={{ required: false }}
            name="SupplierType"
            placeholder="Select"
            Controller={Controller}
            control={control}
            register={register}
            options={[
              { value: "", label: "All" },
              { value: 1, label: "Indian" },
              { value: 2, label: "Overseas" },
              // Add more options as needed
            ]}
            mandatory={false}
            handleChange={(value) => {
              //   handleSelectChange(value);
            }}
            errors={errors?.SupplierType}
            // disabled={filter === "0" || filter === "3"}
          />
        </Col>
        <Col md="12">
          <SearchableSelectHookForm
            {...register("Country")}
            label="Country"
            rules={{ required: false }}
            name="Country"
            placeholder="Select"
            Controller={Controller}
            control={control}
            register={register}
            options={renderListing("country")}
            mandatory={false}
            handleChange={(value) => {
              //   handleSelectChange(value);
            }}
            errors={errors?.TypeOfEstablishment}
            disabled={filter === "0" || filter === "3"|| filter === "1"}
          />
        </Col>
        <Col md="12">
          <TextFieldHookForm

            label={`City`}
            name={"City"}
            Controller={Controller}
            control={control}
            register={register}
            placeholder={"Enter"}
            rules={{
              required: false,
              // validate: { checkWhiteSpaces },
              maxLength: 50,
            }}
            handleChange={() => { }}
            customClassName={"withBorder"}
            errors={errors.City}
            disabled={filter === "0" || filter === "3"|| filter === "1"}
            mandatory={false}
          />
        </Col>
        <Col md="12">
          <TextFieldHookForm

            label={`Supplier Name`}
            name={"supplierName"}
            Controller={Controller}
            control={control}
            placeholder={"Enter"}
            register={register}
            rules={{
              required: false,
              //   validate: { checkWhiteSpaces, email },
              maxLength: 100,
            }}
            handleChange={() => { }}
            customClassName={"withBorder"}
            errors={errors.supplierName}
            disabled={false}
            mandatory={false}
          />
        </Col>
        <Col md="12">
          <TextFieldHookForm
            label={`PAN Number`}
            name={"panNo"}
            Controller={Controller}
            control={control}
            placeholder={"Enter"}
            rules={{
              required: false,
              pattern: {
                value: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
                message: "Invalid PAN Number format.",
              },
              maxLength: 25,
            }}
            register={register}
            handleChange={(e) => {
              const uppercaseValue =
                e.target.value.toUpperCase(); // Convert input2 value to  a uppercase
              e.target.value = uppercaseValue;
            }}
            customClassName={"withBorder"}
            className="text-uppercase"
            errors={errors.panNo}
            disabled={filter === "0" || filter === "3"||filter === "1"}
            mandatory={false}
          />
        </Col>

        {/* Repeat the pattern for other fields */}
        <div className="mt-3 d-flex">
          <Button
            type="primary"
            className="btn-primary supp-search-btn mr-1"
            htmlType="submit"
          >
            Search
          </Button>
          <Button
            type="primary"
            className="btn-secondry ml-1"
            onClick={handleReset}
          >
            Reset
          </Button>
        </div>
      </form>
    </div>
  );
};
export default MasterFilterComponent;
